// extracted by mini-css-extract-plugin
export default {"loginPageBackground":"LoginPage__loginPageBackground__a1eOH"};